import React, { useState } from 'react';
import { Box, Typography, IconButton, Alert, List, ListItem, ListItemText } from '@mui/material';
import { Icon } from "@iconify/react";
export const InfoBanner = ({ title = "Important Notice", message = "When handling the case, please indicate the cause of the alarm and/or indicate An explanation. You can also describe action taken.", bulletPoints = [], onClose, visible = true, variant = 'alarm', }) => {
    const [isVisible, setIsVisible] = useState(visible);
    const handleClose = () => {
        setIsVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    if (!isVisible)
        return null;
    // Shared styles
    const titleStyles = {
        color: "info.dark",
        // mb: 1,
    };
    const bodyTextStyles = {
        color: "text.dark",
    };
    const alertStyles = {
        backgroundColor: "#00B8D914",
        border: "1px solid",
        borderColor: "#00B8D929",
        borderRadius: 4,
        alignItems: "flex-start",
        "& .MuiAlert-icon": {
            color: "info.main",
            fontSize: "20px",
        },
        "& .MuiAlert-message": {
            padding: 0,
            flex: 1,
        },
        "& .MuiAlert-action": {
            padding: 0,
            marginRight: 0,
            alignItems: "flex-start",
        },
    };
    const closeButtonStyles = {
        color: "info.dark",
        "&:hover": {
            backgroundColor: "info.lighter",
        },
    };
    // Reusable title component
    const Title = () => (React.createElement(Typography, { variant: "subtitle1", sx: titleStyles }, title));
    // Content rendering based on variant
    const renderContent = () => {
        const isUserVariant = variant === 'user' && bulletPoints.length > 0;
        return (React.createElement(Box, null,
            React.createElement(Title, null),
            isUserVariant ? (React.createElement(List, { sx: { py: 0, pl: 2 } }, bulletPoints.map((point, index) => (React.createElement(ListItem, { key: index, sx: { py: 0, pl: 0, display: 'list-item' } },
                React.createElement(ListItemText, { primary: React.createElement(Typography, { variant: "body2", sx: Object.assign(Object.assign({}, bodyTextStyles), { display: 'list-item', listStyleType: 'disc', listStylePosition: 'outside', ml: 0 }) }, point) })))))) : (React.createElement(Typography, { variant: "body2", sx: Object.assign(Object.assign({}, bodyTextStyles), { whiteSpace: 'pre-wrap', lineHeight: 1.5, wordWrap: 'break-word' }) }, message))));
    };
    return (React.createElement(Alert, { severity: "info", sx: alertStyles, icon: React.createElement(Icon, { icon: "eva:alert-circle-fill" }), action: React.createElement(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleClose, sx: closeButtonStyles },
            React.createElement(Icon, { icon: "eva:close-outline" })) }, renderContent()));
};
